import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';  
import { switchMap, map } from 'rxjs/operators';

import { CollectionReportData, CollectionReport } from '../../../interfaces/report/collectionReport' ;
import { CollectionReportApi } from '../api/collectionReport.api';
import { HttpParams } from '@angular/common/http';
@Injectable()
export class CollectionReportService extends CollectionReportData {

    constructor(private api: CollectionReportApi) {
      super();
    }


    list(url: string,queryParams:HttpParams): Observable<CollectionReport[]> {
      if(!!queryParams) {
        return this.api.list(url,queryParams);
      }
      else {
        return this.api.list(url);
      }
      
    }

    getById(url:string): Observable<CollectionReport>{
        return this.api.getById(url);
    }

    create(url: string, data:CollectionReport): Observable<CollectionReport[]> {
      return this.api.add(url,data);
    }
    createLabMaster(url: string, data:any): Observable<any> {
      return this.api.add(url,data);
    }
    updateLabMaster(url: string, data:any): Observable<any> {
      return this.api.updateLabMaster(url,data);
    }

    update(url: string, data:CollectionReport): Observable<CollectionReport[]> {
      return this.api.update(url,data);
    }



    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
 
    searchList(url: string,data:any): Observable<any> {
       
        return this.api.searchList(url,data);
      }
  }
